import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { AppUserAuth } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class QrCodeLoginService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  login(code: string): Observable<AppUserAuth> {
    const url = `${this.globals.apiRoot}/JwtAutoLogin/LoginQrCode/${code}`;
    return this.http.post<AppUserAuth>(url, { code });
  }
}
